import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: number): number {
    return Math.round(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/round-pipe/round.pipe.ts